// Helpers for the tester completion redirect.
//
// When someone arrives via /tester/?iid=SOMETHING, TesterLogin stashes that
// iid in localStorage. When they finish the study (submit feedback OR click
// "Finish study"), we send them to a friendly thank-you page on our own
// domain — NOT to User Interviews — so testers from Reddit, Facebook groups,
// or anywhere else get a warm landing instead of a third-party redirect.
//
// Everything they did is already in your admin dashboard (Admin → Beta
// activity → User Interviews funnel), keyed by their iid.

const COMPLETION_PATH = "/study-complete";

export function getParticipantId() {
    try {
        return (
            sessionStorage.getItem("mlcn_participant_id") ||
            localStorage.getItem("mlcn_participant_id") ||
            ""
        ).trim();
    } catch (_e) {
        return "";
    }
}

export function buildCompletionUrl(iid) {
    if (!iid) return "";
    return `${COMPLETION_PATH}?iid=${encodeURIComponent(iid)}`;
}

export function clearParticipantId() {
    try {
        sessionStorage.removeItem("mlcn_participant_id");
        localStorage.removeItem("mlcn_participant_id");
    } catch (_e) { /* noop */ }
}

// Lets the Finish-study gate decide whether to nag the tester to fill out the
// survey or to let them bounce straight back to User Interviews.
export function markFeedbackSubmitted(iid) {
    if (!iid) return;
    try {
        localStorage.setItem(`mlcn_feedback_submitted_${iid}`, new Date().toISOString());
    } catch (_e) { /* noop */ }
}

export function hasFeedbackSubmitted(iid) {
    if (!iid) return false;
    try {
        return !!localStorage.getItem(`mlcn_feedback_submitted_${iid}`);
    } catch (_e) {
        return false;
    }
}
